import axios from 'axios';
import * as CryptoJS from 'crypto-js';
import router from "@/router";

const service = axios.create({
  baseURL: '/api',
});
// Add a response interceptor
service.interceptors.response.use(
  function (response) {
    // Do something with response data
    console.log(response)
      return response;
  },
  function (error) {
    var parse = JSON.parse(JSON.stringify(error));
    switch (parse.response.status) {
      case 424:
      case 401:
      case 422:
      case 400:
        alert(parse.response.data.msg)
        router.push('/login');
        break;
      case 500:
        alert(parse.response.data.msg)
    }
    return Promise.reject(error);
  }
);

function refreshTokenApi(refresh_token) {
  const grant_type = 'refresh_token';
  const scope = 'server';
  // 获取当前选中的 basic 认证信息
  const basicAuth = window.sessionStorage.getItem('basicAuth');
  return service.request({
    url: '/auth/oauth2/token',
    headers: {
      Authorization: basicAuth,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'post',
    params: {refresh_token: refresh_token, grant_type: grant_type, scope: scope},
  });
}


/**
 * 刷新token方法
 * @function refreshToken
 * @async
 * @returns {Promise<any>}
 */
async function refreshToken() {
  return new Promise((resolve, reject) => {
    const refreshToken = window.sessionStorage.getItem('refresh_token');
    refreshTokenApi(refreshToken)
      .then((res) => {
        // 存储token 信息
        window.sessionStorage.setItem('token', res.data.access_token);
        window.sessionStorage.setItem('refresh_token', res.data.refresh_token);
        resolve(res);
      })
      .catch((err) => {
        // useMessage().error(err.msg);
        reject(err);
      });
  });
}


/**
 * 校验令牌，若有效期小于半小时自动续期
 * @param refreshTime
 * @param refreshLock
 */
export const checkToken = (refreshTime, refreshLock) => {
  const basicAuth = window.sessionStorage.getItem('basicAuth');
  service.request({
    url: '/auth/token/check_token',
    headers: {
      Authorization: basicAuth,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'get',
    params: {token: window.sessionStorage.getItem("token")},
  })
    .then((res) => {

      const response = res.data;
      if (validateNull(response) || response.code === 1) {
        clearInterval(refreshTime);
        return;
      }
      const expire = Date.parse(response.data.expiresAt);
      if (expire) {
        const expiredPeriod = expire - new Date().getTime();
        //小于半小时自动续约
        if (expiredPeriod <= 30 * 60 * 1000) {
          if (!refreshLock) {
            refreshLock = true;
            refreshToken()
              .catch(() => {
                clearInterval(refreshTime);
              });
            refreshLock = false;
          }
        }
      }
    })
    .catch((error) => {
      // 发生异常关闭定时器
      clearInterval(refreshTime);
      switch (error.response.status) {
        case 424:
        case 401:
          alert("登录已过期,请重新登录")
          router.push('/login');
          break;
      }

    });
}
/**
 * 判断是否为空
 * @param val 数据
 */
export const validateNull = (val) => {
  if (typeof val === 'boolean') {
    return false;
  }
  if (typeof val === 'number') {
    return false;
  }
  if (val instanceof Array) {
    if (val.length === 0) return true;
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true;
  } else {
    if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') return true;
    return false;
  }
  return false;
};
/**
 * 登录
 * @param data
 */
export const login = async (data) => {
  const basicAuth = 'Basic ' + window.btoa('student:student');
  window.sessionStorage.setItem('basicAuth', basicAuth);
  // 密码加密
  const encPassword = encryption(data.password, 'pigxpigxpigxpigx');
  var randomStr = new Date().getTime()
  const {username, grant_type, scope} = data;
  const params = new URLSearchParams();
  params.append('password', encPassword);
  return service.request({
    url: '/auth/oauth2/token',
    method: 'post',
    params: {username, randomStr, grant_type, scope},
    data: params,
    headers: {
      Authorization: basicAuth,
      'CLIENT-TOC': 'Y',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

/**
 *加密处理
 */
function encryption(src, keyWord) {
  const key = CryptoJS.enc.Utf8.parse(keyWord);
  // 加密
  var encrypted = CryptoJS.AES.encrypt(src, key, {
    iv: key,
    mode: CryptoJS.mode.CFB,
    padding: CryptoJS.pad.NoPadding,
  });
  return encrypted.toString();
}

export const dologin = (data) => {
  data.grant_type = 'password';
  data.scope = 'server';

  return new Promise((resolve, reject) => {
    login(data)
      .then((res) => {
        if (res.data.ok === false){
          console.log(res)
          reject(err);
        }
        // 存储token 信息
        window.sessionStorage.setItem('token', res.data.access_token);
        window.sessionStorage.setItem('refresh_token', res.data.refresh_token);
        resolve(res);
      })    .catch((err) => {
      // useMessage().error(err.msg);
      reject(err);
    });
  });
}


export const doAuthorizationLogin = (data) => {
  // data.grant_type = 'authorization_code';
  // data.scope = 'server';

  return new Promise((resolve, reject) => {
    authorizationLogin(data)
      .then((res) => {
        if (res.data.ok === false){
          reject(err);
        }
        // 存储token 信息
        window.sessionStorage.setItem('token', res.data.access_token);
        window.sessionStorage.setItem('refresh_token', res.data.refresh_token);
        resolve(res);
      })
      .catch((err) => {
        // useMessage().error(err?.msg || '系统异常请联系管理员');
        reject(err);
      });
  });
}

export const authorizationLogin = (data) => {
  const grant_type = 'mobile';
  const scope = 'server';
  const basicAuth = 'Basic ' + window.btoa('student:student');
  window.sessionStorage.setItem('basicAuth', basicAuth);
  const {code} = data;
  const mobile = code;
  return service.request({
    url: '/auth/oauth2/token',
    method: 'post',
    params: {mobile, grant_type, scope},
    headers: {
      Authorization: basicAuth,
      'CLIENT-TOC': 'Y',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};
export const logout = async () => {
  await service.request({
    url: '/auth/token/logout',
    method: 'delete',
    headers: {
      Authorization: `Bearer ${window.sessionStorage.getItem('token')}`,
      'CLIENT-TOC': 'Y',
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  });
  window.sessionStorage.removeItem('token')
}


export const downLoadExcellent = async (query) => {
  return new Promise((resolve, reject) => {
    service.request({
      url: '/adult/admin/gradGreatDegree/export',
      method: 'get',
      responseType: 'blob',
      data: query,
      headers: {
        Authorization: `Bearer ${window.sessionStorage.getItem('token')}`,
        // 'CLIENT-TOC': 'Y',
        // 'Content-Type': 'application/x-www-form-urlencoded',
      }
    }).then((res)=>{
        resolve(res);
    }).catch((err) => {
        reject(err);
    });
  })
}
